import { CircularProgress, Tooltip } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import type { FC } from "react";
import { useState } from "react";
import toast from "react-hot-toast";

import type { Database } from "../../../../../__definitions__/database-definitions";
import { useApiServiceCallback } from "../../../../../server/api/client";
import { Refresh } from "../../../../../styles/icons/refresh";
import { CustomEmailDomainsService } from "../../client/custom-email-domains-service";
import type { CustomEmailDomain } from "../../server/supabase-custom-email-domain-service";

export const RefreshButton: FC<{
  customEmailDomain: CustomEmailDomain;
  onVerified: () => void;
}> = ({ customEmailDomain, onVerified }) => {
  const [refreshing, setRefreshing] = useState(false);

  const handleCheckStatus = useApiServiceCallback(
    CustomEmailDomainsService,
    async (
      { apiService },
      emailDomain: Database["public"]["Tables"]["custom_email_domain"]["Row"],
    ): Promise<void> => {
      setRefreshing(true);

      const { data } = await apiService.refreshVerifiedStatus(emailDomain.id);

      if (data) {
        if (data.verified) {
          toast.success(`${emailDomain.domain} has been verified.`);
          onVerified();
        } else {
          toast(`${emailDomain.domain} has not yet been verified.`, {
            icon: "⚠️",
          });
          setRefreshing(false);
        }
      } else {
        toast.error(`Something went wrong when refreshing status for ${emailDomain.domain}`);
        setRefreshing(false);
      }
    },
    [onVerified],
  );

  return (
    <GridActionsCellItem
      key="refresh"
      icon={
        <Tooltip title={`Refresh Status for ${customEmailDomain.domain}`} placement="right">
          {refreshing ? <CircularProgress size="small" /> : <Refresh fontSize="small" />}
        </Tooltip>
      }
      label={`Refresh Status for ${customEmailDomain.domain}`}
      aria-label={`Refresh Status for ${customEmailDomain.domain}`}
      showInMenu={false}
      onClick={() => {
        void handleCheckStatus(customEmailDomain).catch(console.error);
      }}
    />
  );
};
